import { useNavigate } from "react-router-dom";
import { ShoppingBag, ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

interface PurchaseConfirmationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  productTitle: string;
  productPrice: string;
}

export function PurchaseConfirmationModal({ 
  isOpen, 
  onOpenChange, 
  productTitle, 
  productPrice 
}: PurchaseConfirmationModalProps) {
  const navigate = useNavigate();

  const handleGoToCart = () => {
    onOpenChange(false);
    navigate('/app/carrinho');
  };

  const handleContinueShopping = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <ShoppingBag className="h-5 w-5 text-green-600" />
            <span>Produto Adicionado!</span>
          </DialogTitle>
          <DialogDescription>
            {productTitle} foi adicionado ao seu carrinho
          </DialogDescription>
        </DialogHeader>
        
        <div className="p-6 space-y-6">
          <div className="bg-muted rounded-lg p-4">
            <div className="flex justify-between items-center">
              <span className="font-medium text-sm">{productTitle}</span>
              <span className="font-bold text-primary">{productPrice}</span>
            </div>
          </div>
          
          <Separator />
          
          <div className="space-y-3">
            <Button 
              onClick={handleGoToCart} 
              className="w-full" 
              size="lg"
            >
              <ArrowRight className="h-4 w-4 mr-2" />
              Finalizar Compra
            </Button>
            
            <Button 
              onClick={handleContinueShopping} 
              variant="outline" 
              className="w-full" 
              size="lg"
            >
              Continuar Comprando
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}